import { render } from "./product_item.vue?vue&type=template&id=21974a0c&scoped=true"
import script from "./product_item.vue?vue&type=script&lang=js"
export * from "./product_item.vue?vue&type=script&lang=js"

import "./product_item.vue?vue&type=style&index=0&id=21974a0c&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21974a0c"]])

export default __exports__